import { render, staticRenderFns } from "./RCTMQ.vue?vue&type=template&id=92884b6c&"
import script from "./RCTMQ.vue?vue&type=script&lang=js&"
export * from "./RCTMQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports